module.exports = __webpack_public_path__ + "laugh.941494c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/profile/laugh.png
// module id = 2090
// module chunks = 0